import { render, staticRenderFns } from "./multipleChoice2.vue?vue&type=template&id=66a4e850&scoped=true"
import script from "./multipleChoice2.vue?vue&type=script&lang=js"
export * from "./multipleChoice2.vue?vue&type=script&lang=js"
import style0 from "./multipleChoice2.vue?vue&type=style&index=0&id=66a4e850&prod&lang=css"
import style1 from "./multipleChoice2.vue?vue&type=style&index=1&id=66a4e850&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a4e850",
  null
  
)

export default component.exports